// config.js

const bizIcon = "https://images.squarespace-cdn.com/content/v1/6704cdea4b9e6d274938d3b9/f118aa60-20d9-4424-8b36-249ee8ba8f1c/atom+ebike+logo+trans.png?format=1000w";
const imageOne = "https://images.squarespace-cdn.com/content/v1/6704cdea4b9e6d274938d3b9/678befd0-547d-4c3a-99be-c7b58e53e65c/image_6487327%288%29.JPG?format=500w";
const imageTwo = "https://s3-media0.fl.yelpcdn.com/bphoto/s1YqM0YQBK6KUYl6tuJaKA/o.jpg";
const imageThree = "https://images.squarespace-cdn.com/content/v1/6704cdea4b9e6d274938d3b9/3797afb8-68cf-4d85-bb34-25a4b2f2a0b6/rental+electric+bike+advertisement+-+Made+with+PosterMyWall%282%29.jpg?format=750w";
const imageFour = "https://images.squarespace-cdn.com/content/v1/6704cdea4b9e6d274938d3b9/7f1e17ab-c863-4c6f-9bdd-7a6556af06d0/IMG_3689.jpeg?format=1000w";
const imageFive = "https://s3-media0.fl.yelpcdn.com/bphoto/6Uf1vv_7DNGGOoJy5crUNQ/o.jpg";

const socialMediaLink = "https://mybizsolutions.us/";

export const siteConfig = {
  title: "Atom E-Bike Repair",
  metaDescription: "Atom E-Bike Repair",
  theme: {
    primaryColor: "red-600",
    secondaryColor: "gray-900",
    accentColor: "text-red-500"
  },
  logo: {
    src: bizIcon,
    alt: "Atom E-Bike Repair",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "Atom E-Bike Repair",
    headline: "Your Premium E-Bike Specialists",
    address: "Norco, California, proudly serving the Inland Empire and surrounding areas",
    description: "Offering top-tier e-bike repairs, parts, and advice tailored to enthusiasts and pros. Dedicated to quality and excellence in e-bike care and maintenance."
},
  images: {
    business: {
      src: imageTwo,
      alt: "Premium Fence Services",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
      description: 'Specializing in premium e-bike repairs and maintenance, we handle every aspect of e-bike care with precision and expertise.',
    },
    {
      description: 'Offering convenient e-bike rentals with flexible options: 2 Hours for $45 or 4 Hours for $80. Rentals include a helmet, require a valid driver\'s license, and a signed waiver for safe and enjoyable rides.',
    },
    {
      description: 'Mobile Service Available: Purchase in-store for same-day pick-up or local delivery. We ensure convenient access to high-quality e-bike solutions for our community in Norco, California.',
    }
  ],
  services: {
    sectionTitle: "Our Services",
    description: "Top-notch e-bike repair and rentals. Get a FREE estimate today!",
    callouts: [
      {
        name: 'E-Bike Repairs',
        description: "We offer diagnostics, throttle repair, controller swaps, motor replacements, tune-ups, and brake services for peak performance.",
        imageSrc: imageOne,
        imageAlt: 'Technician performing e-bike repairs',
      },
      {
        name: 'E-Bike Rentals',
        description: "Town rides for 2 Hours ($45) or 4 Hours ($80). Includes helmet, valid ID, and signed waiver.",
        imageSrc: imageThree,
        imageAlt: 'E-bike ready for rental',
      },
      {
        name: 'Mobile Service',
        description: "Purchase in-store for same-day pick-up or local delivery.",
        imageSrc: imageFour,
        imageAlt: 'Mobile e-bike service vehicle',
      }
    ]
  },  
  about: {
    sectionTitle: "About Us",
    description: "Welcome to Atom E-Bike Repair, established in 2020 and nestled in the heart of Norco, California. We are your trusted hub for expert e-bike and electric scooter repair, customization, and maintenance. Our dedicated team specializes in enhancing your e-bike experience, offering reliable services to ensure every ride is smooth and enjoyable. Whether you're looking for a repair, upgrade, or custom modification, Atom E-Bike Repair is your partner in electric journeys.",
    image: {
        src: imageFive,
        alt: "Atom E-Bike Repair team working on an electric bike",
        width: 2432,
        height: 1442
    }
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "816 6th Street, Suite B, Norco, CA 92860, USA",
    googleMapsEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3298.0950422348087!2d-117.5636794849384!3d33.93125598063679!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcafe0e2842b5f%3A0xa3e4c5d2d8e22c11!2s816%206th%20St%20Suite%20B%2C%20Norco%2C%20CA%2092860%2C%20USA!5e0!3m2!1sen!2sph!4v1710407450828!5m2!1sen!2sph",
    subCategories: [
      { name: 'Apple Maps', url: 'https://maps.apple.com/?address=816%206th%20Street,%20Norco,%20CA%2092860&ll=33.931256,-117.563679&q=816%206th%20Street,%20Norco,%20CA' },
      { name: 'Bing Maps', url: 'https://www.bing.com/maps?q=816+6th+Street,+Norco,+CA+92860&form=HDRSC6&sp=1' },
      { name: 'Google Earth', url: 'https://earth.google.com/web/search/816+6th+Street,+Norco,+CA+92860' },
      { name: 'Google Maps', url: 'https://maps.app.goo.gl/8R4jJHGJdKj9ETq89' }
    ]
  },
  contact: {
    sectionTitle: "Ready to Enhance Your E-Bike Experience?",
    description: "Get in touch to discuss your e-bike repair, rental, or customization needs. Whether you're looking for a tune-up, a new part, or expert advice, we’re here to keep your e-bike running smoothly and reliably.",
    socialLinks: {
      facebook: socialMediaLink,
      instagram: socialMediaLink,
      twitter: socialMediaLink,
      youtube: socialMediaLink,
      tiktok: socialMediaLink
    },
    contactNumbers: ["(951) 233-9188"],
    logo: bizIcon,
    emailRecipient: "WebDev@bizsolutions.us"
  },
  emailConfig: {
    userId: "ltKCDy-yJAdOiH5va",
    serviceId: "service_xazf67t",
    templateId: "template_8k3chhc"
  },
  footer: {
    bizSolutionsLogo: "https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg"
  }
};
